import api from "../config/apiConfig";
import { getSelectedCompany } from "../utils/auth";
import { getAdminId, getRegisterId } from "../utils/authId";

export const FetchForwardApi = async (data) => {
  const adminId = getAdminId();
  const companyId = getSelectedCompany();
  const reId = getRegisterId();
  try {
    const response = await api.get(
      `api/get_forward_msg_list/?admin=${adminId}&company_id=${companyId.id}&register_id=${reId}${data}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
